

















































































































































import Vue, { PropType } from "vue";
import { PosConfiguration, PosConfigurationType } from "@/common/models/PosConfiguration";
import { FieldRules } from "@/common/utils/FieldRules";

export default Vue.extend({
  name: "PosConfigurationEdit",
  props: {
    model: {
      type: Object as PropType<PosConfiguration>,
      required: true,
    },
  },
  data() {
    return {
      PosConfigurationType,
      typeValues: Object.values(PosConfigurationType).map((type) => {
        return { text: type, value: type };
      }),
      orderTTLTimePickerOpen: false,
      suspendTTLTimePickerOpen: false,
      ...FieldRules,
    };
  },
  methods: {
    getOrderTTL(): string | null {
      const config = new PosConfiguration(null, null, null, null, null, null, null, null, null, null);
      Object.assign(config, this.model);
      return config.getOrderTTLAsTime() ?? "00:00:00";
    },
    setOrderTTL(orderTTL: string | null): void {
      const config = new PosConfiguration(null, null, null, null, null, null, null, null, null, null);
      Object.assign(config, this.model);
      config.setOrderTTLFromTime(orderTTL);
      this.model.orderTTL = config.orderTTL;
    },
    getSuspendTTL(): string | null {
      const config = new PosConfiguration(null, null, null, null, null, null, null, null, null, null);
      Object.assign(config, this.model);
      return config.getSuspendTTLAsTime() ?? "00:00:00";
    },
    setSuspendTTL(suspendTTL: string | null): void {
      const config = new PosConfiguration(null, null, null, null, null, null, null, null, null, null);
      Object.assign(config, this.model);
      config.setSuspendTTLAsTime(suspendTTL);
      this.model.suspendTTL = config.suspendTTL;
    },
  },
});
